
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import SignUpDialog from "@/components/SignUpDialog";
import Logo from "@/components/header/Logo";
import DesktopNavigation from "@/components/header/DesktopNavigation";
import MobileMenu from "@/components/header/MobileMenu";
import { useAdminStatus } from "@/hooks/useAdminStatus";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSignUpDialogOpen, setIsSignUpDialogOpen] = useState(false);
  const { isAdmin } = useAdminStatus();
  const navigate = useNavigate();

  const handleAdminAccess = () => {
    if (isAdmin) {
      navigate('/admin/dashboard');
    } else {
      setIsSignUpDialogOpen(true);
    }
  };

  return (
    <header className="bg-elfPink-light py-3 sticky top-0 z-50">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Logo />

        {/* Desktop Navigation */}
        <DesktopNavigation 
          isAdmin={isAdmin}
          onSignUpClick={() => setIsSignUpDialogOpen(true)}
          onAdminDashboardClick={() => navigate('/admin/dashboard')}
        />

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-foreground"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Navigation - Only render when isMenuOpen is true */}
        {isMenuOpen && (
          <MobileMenu 
            isOpen={isMenuOpen}
            isAdmin={isAdmin}
            onClose={() => setIsMenuOpen(false)}
            onSignUpClick={() => setIsSignUpDialogOpen(true)}
            onAdminDashboardClick={() => navigate('/admin/dashboard')}
          />
        )}
      </div>
      
      <SignUpDialog open={isSignUpDialogOpen} onOpenChange={setIsSignUpDialogOpen} />
    </header>
  );
};

export default Header;
